import _ from "lodash";

let lockData = false;

let lockInstance: any | undefined;

let resolveMethod: any;

// 设置锁
export const lock = () => {
  console.log("设置题目切换的锁");
  lockData = true;
};

export const unLock = () => {
  if (lockData === true) {
    console.log("释放锁");
    lockData = false;
    // 同时解除instance的数据
    if (resolveMethod) {
      resolveMethod();
      lockInstance = undefined;
      resolveMethod = undefined;
    }
  }
};

export const checkLockFree = () => {
  // 无锁状态
  if (lockData === false) {
    return;
  }
  // 有锁，但是还没有实例
  if (!lockInstance) {
    lockInstance = new Promise((resolve, reject) => {
      resolveMethod = resolve;
      _.delay(() => {
        reject(new Error("等待释放锁超时"));
        lockInstance = undefined;
        resolveMethod = undefined;
      }, 1000 * 60 * 5);
    });
  }
  return lockInstance;
};
